import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["maxLevel", "iso", "includeList", "excludeList", "defaultValue", "value", "hideSensitiveDivision", "showDisabledDivision"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useRef, useState } from 'react';
import { CnCascaderSelect } from '@cainiaofe/cn-ui-m';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { checkSDK, DataServices, formatDataToNorm, handleFilterCoutries, handleFilterSpicialData, handleFilterDivisions, isCN, findPathByValue, transferObjToAvailable, getDetailValueDS } from "./utils";
var WrapCascaderSelect = function WrapCascaderSelect(props) {
  var _props$maxLevel = props.maxLevel,
    maxLevel = _props$maxLevel === void 0 ? 5 : _props$maxLevel,
    _props$iso = props.iso,
    iso = _props$iso === void 0 ? 'CN' : _props$iso,
    includeList = props.includeList,
    excludeList = props.excludeList,
    defaultValue = props.defaultValue,
    value = props.value,
    _props$hideSensitiveD = props.hideSensitiveDivision,
    hideSensitiveDivision = _props$hideSensitiveD === void 0 ? true : _props$hideSensitiveD,
    _props$showDisabledDi = props.showDisabledDivision,
    showDisabledDivision = _props$showDisabledDi === void 0 ? false : _props$showDisabledDi,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  // 获取初始值
  var getInitValue = function getInitValue(props) {
    var value = props.value,
      defaultValue = props.defaultValue,
      _props$useDetailValue = props.useDetailValue,
      useDetailValue = _props$useDetailValue === void 0 ? false : _props$useDetailValue;
    var v = value || defaultValue || '';
    if (useDetailValue) {
      return transferObjToAvailable(v, _extends({}, props, {
        showTopLevel: true
      }));
    }
    return v;
  };
  var initValue = getInitValue(props);
  var dataServices = useRef(null);
  var _useState = useState([]),
    dataSource = _useState[0],
    setDataSource = _useState[1];
  var _useState2 = useState(''),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var _useState3 = useState(false),
    isInited = _useState3[0],
    setIsInited = _useState3[1];
  // 用于记录某级数据是否已经加载过
  var _useState4 = useState({}),
    divisionLoadState = _useState4[0],
    setDivisionLoadState = _useState4[1];
  useEffect(function () {
    !isInited && init();
  }, [props.value]);
  useEffect(function () {
    var propsValue = getInitValue(props);
    if (isInited && propsValue !== innerValue) {
      getRegionChainData(propsValue, dataSource);
    }
  }, [props.value]);
  var init = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var topLevelInfo, topLevelList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return checkSDK();
          case 2:
            // 请求实例
            dataServices.current = new DataServices({
              config: _extends({
                iso: iso
              }, props.config || {}, {
                hideSensitiveDivision: hideSensitiveDivision
              })
            });
            if (!iso) {
              _context.next = 10;
              break;
            }
            _context.next = 6;
            return getTopLevelInfo();
          case 6:
            topLevelInfo = _context.sent;
            if (topLevelInfo && initValue) {
              getRegionChainData(initValue, topLevelInfo);
            }
            _context.next = 14;
            break;
          case 10:
            _context.next = 12;
            return getTopLevelList();
          case 12:
            topLevelList = _context.sent;
            if (topLevelList && initValue) {
              getRegionChainData(initValue, topLevelList);
            }
          case 14:
            setIsInited(true);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function init() {
      return _ref.apply(this, arguments);
    };
  }();

  // 获取某个国家数据
  var getTopLevelInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var res, newData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dataServices === null || dataServices === void 0 ? void 0 : dataServices.current.getTopLevelInfo({
              iso: iso
            });
          case 2:
            res = _context2.sent;
            if (res) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", console.error('CnAddressM Error: No data，please check your "iso" '));
          case 5:
            newData = formatDataToNorm([res], _extends({}, props));
            setDataSource(newData);
            return _context2.abrupt("return", newData);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getTopLevelInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  // 获取国家列表
  var getTopLevelList = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res, filterData, isLeaf, newData, findIndex, CNData, mergeData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return dataServices === null || dataServices === void 0 ? void 0 : dataServices.current.getTopLevelList();
          case 2:
            res = _context3.sent;
            if (res) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", []);
          case 5:
            filterData = handleFilterCoutries(res, includeList, excludeList, showDisabledDivision);
            isLeaf = maxLevel === 1;
            newData = formatDataToNorm(filterData, _extends({}, props, {
              isLeaf: isLeaf
            })); // move CN to the first place
            findIndex = newData.findIndex(function (country) {
              return country.value === '1';
            });
            CNData = findIndex > -1 ? newData.splice(findIndex, 1) : [];
            mergeData = [].concat(CNData, newData);
            setDataSource(mergeData);
            return _context3.abrupt("return", mergeData);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getTopLevelList() {
      return _ref3.apply(this, arguments);
    };
  }();

  // 动态加载数据
  var handleLoadData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(item) {
      var _dataServices$current, _extends2;
      var divisionId, level, res, state, filterSpicialData, filterDivisionsData, isLeaf, formatData, getCurrentPath, newData;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            divisionId = item.value;
            level = item.protoData.level;
            _context4.next = 4;
            return (_dataServices$current = dataServices.current) === null || _dataServices$current === void 0 ? void 0 : _dataServices$current.getChildren({
              divisionId: divisionId
            });
          case 4:
            res = _context4.sent;
            if (!divisionLoadState[divisionId]) {
              _context4.next = 7;
              break;
            }
            return _context4.abrupt("return", dataSource);
          case 7:
            state = _extends({}, divisionLoadState, (_extends2 = {}, _extends2[divisionId] = true, _extends2));
            setDivisionLoadState(state);

            // 仅在中国且是第二级时过滤，处理内地或港澳台
            filterSpicialData = isCN(iso) && level === 1 ? handleFilterSpicialData((res === null || res === void 0 ? void 0 : res.divisions) || res, props) : (res === null || res === void 0 ? void 0 : res.divisions) || res; // 可用数据过滤
            filterDivisionsData = handleFilterDivisions(filterSpicialData, props); // 判断层级是否为所需级别
            isLeaf = level === maxLevel - 1;
            formatData = formatDataToNorm(filterDivisionsData, _extends({}, props, {
              isLeaf: isLeaf
            })); // get keyPath in 'dataSource'
            getCurrentPath = onSelectItem(item);
            newData = cloneDeep(dataSource);
            set(newData, getCurrentPath, formatData);
            setDataSource(newData);
            return _context4.abrupt("return", newData);
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleLoadData(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  // 点击某一项
  var onSelectItem = function onSelectItem(item) {
    return getSelectPath(item.value, dataSource);
  };

  // 获取数据链路径
  var getSelectPath = function getSelectPath(value, datas) {
    var getPathData = findPathByValue(value, datas);
    if (!getPathData || (getPathData === null || getPathData === void 0 ? void 0 : getPathData.length) === 0) return [];
    var newSelectPath = [];
    getPathData.forEach(function (item) {
      newSelectPath.push(item.index.toString());
      newSelectPath.push('children');
    });
    return newSelectPath;
  };

  // 获取区划数据链
  var getRegionChainData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(divisionId, list) {
      var chainData, chainDataIds, ids, len, state, i, id, filterChainData;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return dataServices === null || dataServices === void 0 ? void 0 : dataServices.current.getRegionChain({
              divisionId: divisionId
            });
          case 2:
            chainData = _context5.sent;
            if (!(chainData.length === 0)) {
              _context5.next = 7;
              break;
            }
            console.error('CnAddressM Error: divisionId is not existed');
            setInnerValue(initValue);
            return _context5.abrupt("return");
          case 7:
            if (!(chainData.length > maxLevel)) {
              _context5.next = 10;
              break;
            }
            console.error('CnAddressM Error: the level of input region does not match the "maxLevel"');
            return _context5.abrupt("return");
          case 10:
            // 记录已加载数据
            chainDataIds = chainData.map(function (o) {
              return o.id;
            });
            ids = chainDataIds.slice(0, chainDataIds.length - 1);
            len = chainDataIds.length;
            state = {};
            for (i = 0; i < len - 2; i++) {
              id = ids[i];
              state[id] = true;
            }
            setDivisionLoadState(state);

            // 过滤跳级数据中可能存在 null 的情况
            filterChainData = chainData.filter(function (o) {
              return o;
            });
            _context5.next = 19;
            return setDefaultDataSource(filterChainData, list);
          case 19:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getRegionChainData(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  // 有默认值时获取数据
  var setDefaultDataSource = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(chainData, list) {
      var childrens, deepMerge, setValue;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            childrens = list || [];
            deepMerge = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var count, id, level, res, filterSpicialData, filterDivisionsData, isLeaf, formatData, newSelectPath;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      count = 0;
                    case 1:
                      if (!(count < chainData.length - 1)) {
                        _context6.next = 16;
                        break;
                      }
                      id = chainData[count].id;
                      level = chainData[count].level;
                      _context6.next = 6;
                      return dataServices.current.getChildren({
                        id: id
                      });
                    case 6:
                      res = _context6.sent;
                      // 仅在中国且是第二级时过滤，处理内地或港澳台
                      filterSpicialData = isCN(iso) && level === 1 ? handleFilterSpicialData((res === null || res === void 0 ? void 0 : res.divisions) || res, props) : (res === null || res === void 0 ? void 0 : res.divisions) || res; // 可用数据过滤
                      filterDivisionsData = handleFilterDivisions(filterSpicialData, props); // 判断层级是否为所需级别
                      isLeaf = level === maxLevel - 1;
                      formatData = formatDataToNorm(filterDivisionsData, _extends({}, props, {
                        isLeaf: isLeaf
                      }));
                      newSelectPath = getSelectPath(id, childrens);
                      set(childrens, newSelectPath, formatData);
                    case 13:
                      count++;
                      _context6.next = 1;
                      break;
                    case 16:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function deepMerge() {
                return _ref7.apply(this, arguments);
              };
            }();
            _context7.next = 4;
            return deepMerge();
          case 4:
            setDataSource(childrens);
            setValue = getInitValue(props);
            setInnerValue(setValue);
            return _context7.abrupt("return", childrens);
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function setDefaultDataSource(_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();

  // 值改变
  var handleChange = function handleChange(value, data, extra) {
    var useDetailValue = props.useDetailValue,
      useDetailMap = props.useDetailMap;
    var v = useDetailValue ? getDetailValueDS(value, extra, useDetailMap, useDetailValue) : value;
    props.onChange && props.onChange(v, data, extra);
    if ('value' in props && !('onChange' in props)) {
      return;
    }
    setInnerValue(value);
  };
  return /*#__PURE__*/React.createElement(CnCascaderSelect, _extends({}, otherProps, {
    value: innerValue,
    dataSource: dataSource,
    loadData: handleLoadData,
    onChange: handleChange
  }));
};
export default WrapCascaderSelect;